import { Component } from '@angular/core';

@Component({
  selector: 'ngx-customer-communications',
  templateUrl: './customer-communications.component.html',
  styleUrls: ['./customer-communications.component.scss']
})
export class CustomerCommunicationsComponent {

}
